import { Text } from '@/components/atoms/text';
import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DimensionNoteContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const StyledStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  maxWidth: '260px',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    maxWidth: 'none',
  },
}));

export const TextValueContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(1),
    alignItems: 'flex-start',
  },
}));

export const TextValue = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '160px',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    maxWidth: 'none',
  },
}));

export const TitleContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down('md')]: {
    maxWidth: '90px',
  },
}));

export const Title = styled(Text)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    fontSize: '0.75rem',
  },
}));

export const Value = styled(Text)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    fontSize: '0.75rem',
  },
}));

export const LabelText = styled(Text)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    fontSize: '0.75rem',
  },
}));
